/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {deleteContacts} from '../api'

export const useMutationDeleteContacts = createReactQueryMutationHook('deleteContacts', deleteContacts)
